module.exports = __webpack_public_path__ + "img/accar.svg";